export type DisclosureContentProps = {
	/**
	 * If set to `true` the content will be shown, otherwise it's hidden.
	 */
	visible?: boolean;
	/**
	 * The content to display within the component.
	 */
	children: React.ReactNode;
};
